<template>
    <div class="shop_register">
        <div class="shop_top"><shop-top :subnav_show="false" :change_color="true"></shop-top></div>
        <div class="shop_login_bg" :style="'background:url('+login_adv+')'">
            <div class="shop_login_block width_center_1200">
                <div class="login_left"><router-link to="/">&nbsp;</router-link></div>
                <div class="login_right">
                    <div class="login_block">
                        <div class="login_title">
                            <ul>
                                <li @click="$router.push('/user/register')">注册账号</li>
                                <li>|</li>
                                <li @click="$router.push('/user/login')">账号登录</li>
                            </ul>
                        </div>
                        <div class="login_input" style="height:250px;">
                            <div class="input_block"><el-input v-model="info.phone" type="text"  @input="handleChange" @change="handleChange" placeholder="手机号"></el-input></div>
                            <div class="input_block" v-show="showAccount">
                                <el-select v-model="info.account" filterable placeholder="请选择用户">
                                <el-option
                                    v-for="item in selectAccount"
                                    :key="item.value"
                                    :label="item.yh"
                                    :value="item.zh">
                                </el-option>
                                </el-select>
                            </div>
                            <div class="input_block"><el-input v-model="info.password" type="password" placeholder="新密码"></el-input></div>
                            <div class="input_block"><el-input v-model="info.password_comp" type="password" placeholder="确认密码"></el-input></div>
                            <div class="input_block"><el-input v-model="info.verification" type="text" style="width:160px;" class="yzm" placeholder="短信验证码"></el-input>
                            <input class="send" v-show="showCount" type="button" @click="send_sms()" value="发送验证码">
                            <input class="send send_count" v-show="!showCount" type="button" :value="'验证码已发送'+count+'s'">
                            </div>
                        </div>
                        <div class="login_btn" @click="to_register">
                            修改密码
                        </div>

                        <div class="login_btn_b">
                            <router-link to="/user/register">没有账号？</router-link>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <shop-foot></shop-foot>
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
export default {
    components: {
        ShopTop,
        ShopFoot,
    },
    props: {},
    data() {
      return {
          login_adv:"/pc/dl4.jpg",
          info:{
              account:'',
              phone:'',
              password:'',
              password_comp:'',
              verification:'',
          },
        userId:null,
        showCount:true,
        count: '',
        timer: null,
        selectAccount:[], //账户列表
        showAccount:false
      };
    },
    watch: {},
    computed: {},
    methods: {
        // 发送短信
        send_sms:function(){
            if(this.$isEmpty(this.info.phone) || this.$isEmpty(this.info.account)){
                return this.$message.error('手机号或账户不能为空');
            }
            if (!/^1[345789]\d{9}$/.test(this.info.phone)) {
                alert(123);
                return this.$message.error('请填写正确的手机号码');
            };
            this.showCount = false;
            this.$get(this.$api.homeSendSms,{phone:this.info.phone,account:this.info.account,platId:this.$platId,type:'1'}).then(res=>{
                if(res.code == 200){
                    this.getCode();
                    this.userId = res.data;
                    return this.$message.success(res.message);
                }else{
                    return this.$message.error(res.message);
                }
            });
        },

        //根据当前手机号获取账号
        handleChange:function(info){
            if(info.length==11){
                this.$get(this.$api.getUserByPhone,{phone:info}).then(res=>{
                    if(res.code=200){
                        if(res.data.length <=1){
                            this.info.account = res.data[0].zh;
                        }else{
                            this.showAccount = true;
                            this.selectAccount = res.data
                        }
                        
                    }else{
                        this.$message.error('没有账户信息!');
                    }
                })
            }

        },

        getCode(){
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.showCount = false;
                this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                } else {
                    this.showCount = true;
                    clearInterval(this.timer);
                    this.timer = null;
                }
                }, 1000)
            }
        } ,

        to_register:function(){
            if(this.$isEmpty(this.info.phone) || this.$isEmpty(this.info.password) || this.$isEmpty(this.info.password_comp) || this.$isEmpty(this.info.verification)){
                return this.$message.error('请先认真填写完整');
            }
            if(this.info.password != this.info.password_comp){
                return this.$message.error('两次密码不相同');
            }
            this.$post(this.$api.homeForgetPassword,{userId:this.userId,password:this.info.password,verification:this.info.verification}).then(res=>{
                if(res.code == 200){
                    this.$message.success(res.message);
                    this.$router.push('/user/login');
                }else{
                    return this.$message.error(res.message);
                }
            });
        }

    },
    created() {
        
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.login_left{
    float: left;
    width: 50%;
    box-sizing: border-box;
    height: 550px;
}
.login_right{
    float: right;
    width: 50%;
    box-sizing: border-box;
    .login_block{
        width: 400px;
        background: #fff;
        height: 450px;
        float: right;
        box-sizing: border-box;
        padding: 40px;
        margin-top:50px;
        .login_title{
            width: 217px;
            margin:0 auto;
            ul:after{
                clear:both;
                display:block;
                content:'';
            }
            ul li{
                float: left;
                margin-right: 20px;
                font-size: 20px;
                color:#444;
                cursor: pointer;
                
            }
            ul li:hover{
                color:#409EFF;
            }
            ul li.colors{
                color:#409EFF;
            }
            ul li:last-child{
                margin-right: 0;
            }
        }
        .login_input{
            margin-top: 30px;
            .input_block{
                margin:15px auto;
                width: 320px;
                input{
                    height: 35px;
                    width: 320px;
                    border:1px solid #e1e1e1;
                    outline:none;
                    padding:0 10px;
                    box-sizing: border-box;
                }
                input.yzm{
                    width: 160px;
                    float: left;
                }
                input.send{
                    background: #333;
                    color:#fff;
                    width: 140px;
                    margin-left: 20px;
                    border: none;
                    cursor: pointer;
                    border-radius: 4px;
                }
                .send_count{
                    font-size: 14px;
                } 
            }
        }
        .login_btn{
            color:#fff;
            background: #409EFF;
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
            a{
                color:#fff;
            }
        }
        .el-divider__text{
            color:#999;
        }
        .login_btn_b{
            text-align: right;
            font-size: 12px;
            color:#666;
            line-height: 45px;
            a{
                color:#666;
            }
            a:hover{
                color:#409EFF;
            }
        }
        .other_login{
            width: 82px;
            margin:0 auto;
            ul li{
                float: left;
                margin-right: 20px;
                cursor: pointer;
                i{
                    font-size: 28px;
                }
            }
            ul li:last-child{
                margin-right: 0;
            }
        }
        
    }
}
.el-select {
    width: 100%;
}
</style>